import BaseDialogContent from '@material-ui/core/DialogContent'

const DialogContent = BaseDialogContent

export default DialogContent
